import {HttpClientService} from '../http-client/http-client.service';
import {GlossaryRecord} from './model/glossary-record.model';
import {map, ReplaySubject} from 'rxjs';

export class GlossaryService {
    static readonly GLOSSARY_APPLICATION_URI = `glossary`;

    private cache: Map<string, ReplaySubject<GlossaryRecord>> = new Map<string, ReplaySubject<GlossaryRecord>>();
    private queued: Set<string> = new Set<string>();

    constructor(
        private http: HttpClientService
    ) {
    }

    get(keyword: string): ReplaySubject<GlossaryRecord> {
        this.collect(keyword);
        return this.cache.get(keyword);
    }

    resolve(): void {
        const queued = Array.from(this.queued.values());

        this.http.get<GlossaryRecord[]>(GlossaryService.GLOSSARY_APPLICATION_URI, {ids: [...queued]})
            .pipe(
                map((glossary: GlossaryRecord[]) => {
                        for (let glossaryRecord of glossary) {
                            this.queued.delete(glossaryRecord.glossaryKey);
                            this.cache.get(glossaryRecord.glossaryKey).next(glossaryRecord);
                        }
                    }
                ))
            .subscribe();
    }

    refresh(): void {
        this.queued = new Set([...this.queued, ...this.cache.keys()]);
        this.cache.clear();
    }

    private initKeyword(keyword: string): void {
        this.cache.set(keyword, new ReplaySubject<GlossaryRecord>(1));
    }

    private collect(keyword: string): void {
        if (this.queued.has(keyword)) {
            return;
        }

        if (this.cache.has(keyword)) {
            return;
        }

        this.initKeyword(keyword);
        this.queued.add(keyword);
    }
}